var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-screen" },
    [
      _c("panel-toolbar", {
        attrs: { period: _vm.period, "show-period": "" },
        on: { "update:period": _vm.changePeriod },
      }),
      _vm.fatalError
        ? _c(
            "b-alert",
            { staticClass: "p-1", attrs: { variant: "warning", show: "" } },
            [_c("small", [_vm._v(_vm._s(_vm.fatalError))])]
          )
        : [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingProfile },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton", { attrs: { width: "45%" } }),
                            _c("b-skeleton", { attrs: { width: "70%" } }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.profile
                  ? _c("profile-header", {
                      attrs: { profile: _vm.profile },
                      on: { "generate-link": _vm.openGenerateLink },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingDashboard },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton-img", {
                              attrs: { "no-aspect": "", height: "180px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.data
                  ? [
                      _c("wallet-summary-card", {
                        attrs: {
                          balances: _vm.data.balances,
                          upcoming: _vm.data.upcoming,
                          title: _vm.$t("influencer_panel.wallet_title"),
                          "show-total": "",
                          "link-to-statement": "",
                        },
                        on: { withdraw: _vm.goToWithdraw },
                      }),
                      _c("performance-strip", {
                        attrs: {
                          metrics: _vm.data.metrics,
                          previous: _vm.data.previous,
                          title: _vm.performanceTitle,
                          subtitle: _vm.data.previous
                            ? _vm.$t("influencer_panel.compared_to_previous")
                            : "",
                        },
                      }),
                      _vm.hasSeries
                        ? _c("commission-chart", {
                            attrs: {
                              current: _vm.data.series.current,
                              previous: _vm.data.series.previous,
                              "current-label": _vm.periodLabelText,
                              "money-hidden": _vm.moneyHidden,
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "panel-screen__pair" },
                        [
                          _vm.hasFunnel
                            ? _c("conversion-funnel", {
                                attrs: { steps: _vm.data.funnel },
                              })
                            : _vm._e(),
                          _vm.hasChannels
                            ? _c("sales-by-channel", {
                                attrs: { channels: _vm.data.channels },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm.dashboardError
              ? _c("section-error", {
                  attrs: { message: _vm.dashboardError },
                  on: { retry: _vm.loadDashboard },
                })
              : _vm._e(),
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingCampaigns },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton-img", {
                              attrs: { "no-aspect": "", height: "140px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                !_vm.campaignsError
                  ? _c("campaign-compact-list", {
                      attrs: {
                        participations: _vm.activeParticipations,
                        "total-sales": _vm.data
                          ? _vm.data.metrics.conversions
                          : 0,
                      },
                      on: {
                        "generate-link": _vm.openGenerateLink,
                        material: _vm.openMaterial,
                        info: _vm.openInfo,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.campaignsError
              ? _c("section-error", {
                  attrs: { message: _vm.campaignsError },
                  on: { retry: _vm.loadCampaigns },
                })
              : _vm._e(),
            _vm.market
              ? _c("market-section", {
                  attrs: {
                    positioning: _vm.market.positioning,
                    timing: _vm.market.timing,
                    opportunities: _vm.market.opportunities,
                  },
                })
              : _vm._e(),
          ],
      _c("generate-link-modal", {
        ref: "generateLink",
        attrs: {
          participations: _vm.joinedParticipations,
          preselected: _vm.linkTarget,
        },
        on: { created: _vm.loadCampaigns },
      }),
      _c("campaign-material-modal", {
        ref: "material",
        attrs: { participation: _vm.materialTarget },
      }),
      _c("campaign-info-modal", { ref: "info" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }